<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="visible"
      :header="form?.id ? 'Editar Cliente' : 'Adicionar Cliente'"
      modal
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
    >
      <form @submit.prevent="submit" ref="form">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label>Nome</label>
            <InputText
              v-model="form.name"
              name="name"
              v-validate="'required|max:255'"
              :class="{ 'p-invalid': errors.has('name') }"
              autocomplete="off"
            />
            <span v-if="errors.has('name')" class="p-error">
              Nome é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Nº Contribuinte</label>
            <InputText
              v-model="form.fiscalNumber"
              name="fiscalNumber"
              v-validate="'max:20'"
              :class="{ 'p-invalid': errors.has('fiscalNumber') }"
              autocomplete="off"
            />
            <span v-if="errors.has('fiscalNumber')" class="p-error">
              Conttribuinte é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Telefone</label>
            <InputText
              v-model="form.telephone"
              name="telephone"
              v-validate="form.mobilPhone == '' ? 'required' : ''"
              :class="{ 'p-invalid': errors.has('telephone') }"
              autocomplete="off"
            />
            <span v-if="errors.has('telephone')" class="p-error">
              Telefone ou Telemóvel é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Telemóvel</label>
            <InputText
              v-model="form.mobilPhone"
              name="mobilPhone"
              v-validate="form.telephone == '' ? 'required' : ''"
              :class="{ 'p-invalid': errors.has('mobilPhone') }"
              autocomplete="off"
            />
            <span v-if="errors.has('mobilPhone')" class="p-error">
              Telefone ou Telemóvel é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Email</label>
            <InputText
              v-model="form.email"
              name="email"
              v-validate="'email'"
              :class="{ 'p-invalid': errors.has('email') }"
              autocomplete="off"
            />
            <span v-if="errors.has('email')" class="p-error">
              Email inválido ou muito longo
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Morada</label>
            <InputText
              v-model="form.address"
              name="address"
              v-validate="'required|max:255'"
              :class="{ 'p-invalid': errors.has('address') }"
              autocomplete="off"
            />
            <span v-if="errors.has('address')" class="p-error">
              Morada é Obrigatória
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4 ">
            <label>Localidade</label>
            <InputText
              v-model="form.city"
              name="city"
              v-validate="'required|max:255'"
              :class="{ 'p-invalid': errors.has('city') }"
              autocomplete="off"
            />
            <span v-if="errors.has('city')" class="p-error">
              Localidade é Obrigatória
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label>Código Postal</label>
            <InputText
              v-model="form.zipCode"
              name="zipCode"
              v-validate="'required|max:20'"
              :class="{ 'p-invalid': errors.has('zipCode') }"
              autocomplete="off"
            />
            <span v-if="errors.has('zipCode')" class="p-error">
              Código Postal é Obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-4 p-mt-4">
            <span class="p-float-label">
              <Dropdown
                v-model="form.country_origin"
                :options="listCountryOrigin"
                v-validate="'required'"
                v-bind:class="[
                  {
                    'p-invalid': errors.has('country_origin'),
                  },
                  'form-control',
                ]"
                :name="'country_origin'"
                :id="'country_origin'"
                optionValue="value"
                optionLabel="label"
                :appendTo="'body'"
              />
              <label for="country_origin">País de Origem</label>
            </span>
            <small v-if="errors.has('country_origin')" class="p-error" role="alert">
              País de origem é obrigatório
            </small>
          </div>
        </div>
      </form>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import ClientService from "@/services/client.service";

export default {
  name: "ClientModal",
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: {},
      listCountryOrigin: [
        {
          label: "Nacional",
          value: '0',
        },
        {
          label: "U.E.",
          value: '1',
        },
        {
          label: "Outros",
          value: '2',
        }
      ],
    };
  },
  watch: {
    visible() {
      this.reset();
      if (this.visible === true) {
        this.$validator.reset();
        this.$validator.resume();
        this.form = { ...this.data };
      }
    },
  },
  methods: {
    reset() {
      this.form = {
        id: null,
        name: "",
        fiscalNumber: "",
        telephone: "",
        mobilPhone: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        country_origin: '0',
      };
      this.$validator.pause();
      this.$validator.reset();
    },
    cancel() {
      this.$validator.pause();
      this.$validator.reset();
      this.reset();
      return this.$emit("cancel");
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      if (this.form.id) {
        await ClientService.update(this.form.id, this.form).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Atualizar Cliente`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Cliente Atualizado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("updated", response);
        });
      } else {
        await ClientService.create(this.form).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Criar Cliente`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Cliente Criado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("created", response);
        });
      }

      this.$emit("saved");
    },
  },
};
</script>
